import dayjs, { type Dayjs } from 'dayjs';
import type { PrivacyPolicyPublicDTO } from '../privacyPolicy.types';

export class PrivacyPolicyPublicModel {
  private readonly _dto: PrivacyPolicyPublicDTO;

  constructor(dto: PrivacyPolicyPublicDTO) {
    this._dto = dto;
  }

  get originDTO(): PrivacyPolicyPublicDTO {
    return this._dto;
  }

  get version(): number {
    return this._dto.version;
  }

  get effectiveDate(): Dayjs {
    return dayjs(this._dto.effectiveDate);
  }

  get title(): string {
    return this._dto.title;
  }

  get content(): string {
    return this._dto.content;
  }

  get formattedEffectiveDate(): string {
    return dayjs(this._dto.effectiveDate).format('YYYY.MM.DD');
  }
}
